import DefaultTheme from '@/lib/theme/default';
import DarkTheme from '@/lib/theme/dark';

const themes = [
  'default',
  'dark'
];

/**
 * Returns theme object for the given theme name.
 * @param themeName - Theme identifier ('default' or 'dark')
 * @returns Theme object (DefaultTheme or DarkTheme)
 */
export function checkTheme(themeName: string) {
  if (themeName && themes.includes(themeName)) {
    switch (themeName) {
      case 'default':
        return DefaultTheme;

      case 'dark':
        return DarkTheme;

      default:
        return DefaultTheme;
    }
  }

  return DefaultTheme;
}

/**
 * Validates and returns theme name if supported.
 * @param themeName - Theme identifier to validate
 * @returns Valid theme name or 'default'
 */
export function checkThemeName(themeName: string) {
  if (themeName && themes.includes(themeName)) {
    switch (themeName) {
      case 'default':
        return 'default';

      case 'dark':
        return 'dark';

      default:
        return 'default';
    }
  }

  return 'default';
}